import React from 'react';
import PropTypes from 'prop-types';
import {ToastWrapper} from './toast.styled';

export const Toast = ({coreText}) => {
	return <ToastWrapper>{coreText}</ToastWrapper>;
};

Toast.propTypes = {
	/**
	 * Main message of the toast, should be a formatted message from Web Component
	 */
	coreText: PropTypes.func,
};

Toast.defaultProps = {
	coreText: 'Toast core text',
};
